import { Heading, Text, VStack } from '@ritualco/jutsu'
import { CardPage } from 'components/PageTemplates'
import { useContent } from 'lib/content/react'

const Complete = () => {
  const { formatMessage } = useContent()
  return (
    <CardPage trackingName="Complete">
      <VStack spacing={3} mb={6}>
        <Text fontSize="small" lineHeight="small">
          {formatMessage({ id: 'pmportal.onboarding.complete' })}
        </Text>
        <Heading as="h1" fontSize="3xlarge" lineHeight="3xlarge">
          {formatMessage({ id: 'pmportal.onboarding.completeTitle' })}
        </Heading>
        <Text fontSize="small" lineHeight="small" color="grayscale.secondary">
          {formatMessage({ id: 'pmportal.onboarding.completeDescription' })}
        </Text>
      </VStack>
    </CardPage>
  )
}

export default Complete
